import { C } from "@/brand/tokens";
import { approach5 } from "@/brand/content";

/**
 * ApproachSection5 — Soft Parchment reveal chamber.
 *
 * Sits between Problem Recognition (patterns) and Services (pathways).
 * Explains the Faith 1st method — the "how we work" that lets buyers
 * decide before scanning offer names. Three disciplined moves,
 * numbered with brass ordinals on a reveal surface so the section
 * carries weight without repeating the dark-hero move.
 */
export function ApproachSection5() {
  return (
    <section
      id="approach"
      data-testid="approach"
      style={{
        background: C.surfaceLight2,
        color: C.textOnLight,
      }}
    >
      <div className="mx-auto max-w-[1240px] px-5 sm:px-8 lg:px-12 py-24 lg:py-32">
        <div className="grid lg:grid-cols-12 gap-10 mb-16">
          <div className="lg:col-span-6">
            <div className="flex items-center gap-4 mb-7">
              <span
                aria-hidden="true"
                className="inline-block h-px w-14"
                style={{ background: C.accentMetal }}
              />
              <p
                className="font-inter text-[11px] uppercase font-semibold"
                style={{
                  color: C.accentMetal,
                  letterSpacing: "0.28em",
                }}
              >
                {approach5.eyebrow}
              </p>
            </div>
            <h2
              className="font-cormorant"
              style={{
                color: C.textOnLight,
                fontSize: "clamp(2rem, 3.6vw, 3rem)",
                fontWeight: 400,
                lineHeight: 1.06,
                letterSpacing: "-0.012em",
              }}
            >
              {approach5.headline}
            </h2>
          </div>
          <div className="lg:col-span-5 lg:col-start-8 lg:pt-3">
            <p
              className="font-inter leading-[1.7] max-w-[44ch]"
              style={{ color: C.inkOnLight, fontSize: "1rem" }}
            >
              {approach5.intro}
            </p>
          </div>
        </div>

        <ol
          className="grid md:grid-cols-3 gap-px"
          style={{ background: C.borderSoft }}
          data-testid="approach-list"
        >
          {approach5.moves.map((m, i) => (
            <li
              key={m.n}
              data-testid={`approach-move-${i}`}
              className="p-10 lg:p-12"
              style={{ background: C.surfaceLight2 }}
            >
              <span
                className="font-cormorant tabular-nums"
                style={{
                  color: C.accentMetal,
                  fontSize: "clamp(1.6rem, 2vw, 1.9rem)",
                  fontWeight: 400,
                  lineHeight: 1,
                  display: "inline-block",
                  paddingBottom: "1.25rem",
                  borderBottom: `1px solid ${C.accentMetal}`,
                }}
              >
                {m.n}
              </span>
              <h3
                className="mt-7 font-cormorant"
                style={{
                  color: C.textOnLight,
                  fontSize: "clamp(1.35rem, 1.9vw, 1.6rem)",
                  fontWeight: 400,
                  lineHeight: 1.2,
                  letterSpacing: "-0.006em",
                }}
              >
                {m.label}
              </h3>
              <p
                className="mt-5 font-inter leading-[1.7]"
                style={{
                  color: C.inkOnLight,
                  fontSize: "0.97rem",
                }}
              >
                {m.body}
              </p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
